import { MasterDataReducer } from './reducers/masterdata.reducer';
import { ActionReducerMap } from '@ngrx/store';
import { MasterDataState } from './state/masterdata.state';
import { SupplierState } from './state/supplierstate.state';
import { SupplierStateReducer } from './reducers/supplierstate.reducer';
import { EventState } from './state/event.state';
import { EventReducer } from './reducers/event.reducers';
import { SoftwareState } from './state/software.state';
import { SoftwareReducer } from './reducers/software.reducer';
import { GeneralSettingsState } from './state/general.state';
import { GeneralReducer } from './reducers/general.reducer';
import { SupplierRatingState } from './state/supplier-rating.state';
import { SupplierRatingReducer } from './reducers/supplier-rating.reducer';
import { SiteState } from './state/site.state';
import { SiteReducer } from './reducers/site.reducer';
import { ProductState } from './state/product.state';
import { ProductReducer } from './reducers/product.reducer';
import { LoanerWheelInventoryReducer } from './reducers/loaner-wheel-inventory.reducer';
import { LoanerWheelInventoryState } from './state/loaner-wheel-inventory.state';
import { OnboardingState } from './state/onboarding.state';
import { OnboardingReducer } from './reducers/onboarding.reducers';
import { TaxState } from './state/tax.state';
import { TaxReducer } from './reducers/tax.reducers';
import { BankReducer } from './reducers/bank.reducers';
import { BankState } from './state/bank.state';
import { SupplierTasksState } from './state/supplier-tasks.state';
import { SupplierTasksReducer } from './reducers/supplier-tasks.reducer';

export class SupplierProfileState {
    MasterData: MasterDataState;
    SupplierState: SupplierState;
    EventState: EventState;
    SoftwareState: SoftwareState;
    GeneralSettingsState: GeneralSettingsState;
    SupplierRatingState: SupplierRatingState;
    SiteState: SiteState;
    ProductState: ProductState;
    LoanerWheelInventoryState: LoanerWheelInventoryState;
    OnboardingState: OnboardingState;
    TaxState: TaxState;
    BankState: BankState;
    SupplierTaskState: SupplierTasksState;
}

export const supplierReducers: ActionReducerMap<SupplierProfileState> = {
    MasterData: MasterDataReducer,
    SupplierState: SupplierStateReducer,
    EventState: EventReducer,
    SoftwareState: SoftwareReducer,
    GeneralSettingsState: GeneralReducer,
    SupplierRatingState: SupplierRatingReducer,
    SiteState: SiteReducer,
    ProductState: ProductReducer,
    LoanerWheelInventoryState: LoanerWheelInventoryReducer,
    OnboardingState: OnboardingReducer,
    TaxState: TaxReducer,
    BankState: BankReducer,
    SupplierTaskState: SupplierTasksReducer
}
